export const DUPLICATE_PROJECT_NAME = "duplicate_project";
export const DUPLICATE_PROJECT_DESC = `Duplicates an existing project via GraphQL mutation.

Use when the user asks to copy/duplicate a project (any type).

Input:
- 'projectId' (required): Source Project ID to duplicate.

Notes:
- Performs a write operation (mutation) and returns the new project's basic fields.
- Also returns 'projectPath' (relative link) and 'projectUrl' (absolute when available) to open the duplicated project.`;
